import { PaymentMethodType } from '#types';
import rpcShared from '@rockpapercoin/rpc-shared';

export const NEW_CARD = 'new-card';
export const NEW_ACH = 'new-ach';

export const MuiPaymentMethodType = {
	CreditCard: 'credit-card',
	AutomatedClearingHouse: 'money-bank',
	PADs: 'money-bank',
} as const;

export type MuiPaymentMethodType =
	( typeof MuiPaymentMethodType )[keyof typeof MuiPaymentMethodType];

export type PaymentMethodOptionsProps = {
	cardConvenienceFeePercentage: number;
	achConvenienceFeePercentage: number;
	isMobile: boolean;
};

const defaultPaymentMethodOrder = [
	PaymentMethodType.card,
	PaymentMethodType.us_bank_account,
	PaymentMethodType.acss_debit,
	PaymentMethodType.apple_pay,
	PaymentMethodType.google_pay,
];

export const getPaymentMethodOrder = (
	prevState: PaymentMethodType[] | undefined,
	paymentMethodType: PaymentMethodType
) =>
	prevState
		? prevState
		: // If the user selected "Bank Account", it's one of the bank options
		[ PaymentMethodType.us_bank_account, PaymentMethodType.acss_debit ].includes(
			paymentMethodType
		  )
			? [
				PaymentMethodType.us_bank_account,
				PaymentMethodType.acss_debit,
				...defaultPaymentMethodOrder.filter(
					( method ) =>
						method !== PaymentMethodType.us_bank_account &&
						method !== PaymentMethodType.acss_debit
				),
		  ]
			: // Otherwise just assume card
		  [
				PaymentMethodType.card,
				...defaultPaymentMethodOrder.filter(
					( method ) => method !== PaymentMethodType.card
				),
		  ];

export const getStatementDescriptorCopy = ( {
	orgName,
	paymentMethodType,
	hasInternationalPayments,
}: {
	orgName: string;
	paymentMethodType: PaymentMethodType;
	hasInternationalPayments: boolean;
} ) => {
	const baseStatementDescriptor = orgName
		? rpcShared.invoices.createStatementDescriptor( orgName )
		: undefined;
	return `This will appear on your ${
		paymentMethodType === PaymentMethodType.card
			? 'card statement'
			: 'bank statement'
	} as ${
		paymentMethodType !== PaymentMethodType.us_bank_account ||
		hasInternationalPayments
			? baseStatementDescriptor
			: 'RPC*' + baseStatementDescriptor?.slice( 0, 17 )
	}`;
};
